const headCells: { id: string, label: string }[] = [
  { id: 'transactionNumber', label: 'Invoice Number' },
  { id: 'bookingNumber', label: 'Booking Number' },
  { id: 'serviceStartDate', label: 'Start Date' },
  { id: 'serviceEndDate', label: 'End Date' },
  { id: 'transactionType', label: 'Charge Type' },
  { id: 'buyerCompanyName', label: 'Buyer' },
  { id: 'createdOn', label: 'Invoice Created' },
  { id: 'buyerAmount', label: 'Buyer Amount' },
  { id: 'paymentProcessorFees', label: 'Payment Processor Amount' },
  { id: 'transactionTaxAmount', label: 'Sales Tax Amount' },
  { id: 'supplierAmount', label: 'Supplier Amount' },
  { id: 'securspaceFees', label: 'SecurSpace Amount' },
  { id: 'paymentType', label: 'Payment Type' },
  { id: 'paymentProcessor', label: 'Payment Processor' },
  { id: 'paymentCreatedOn', label: 'Payment Initiated' },
  { id: 'paymentCompletedOn', label: 'Process Completed' },
  { id: 'payoutCreatedOn', label: 'Payout Initiated' },
  { id: 'payoutCompletedOn', label: 'Payout Completed' },
  { id: 'supplierPayoutOnHold', label: 'Payout On Hold' },
  { id: 'bookingStatus', label: 'Booking Status' },
  { id: 'numberOfSpaces', label: 'Spaces' },
  { id: 'assetType', label: 'Equipment Type' },
  { id: 'serviceFeeType', label: 'Service Charge Type' },
  { id: 'bookingCreatedOn', label: 'Booking Created On' },
  { id: 'bookingCreatedBy', label: 'Booking Created By' },
  { id: 'supplierCompanyName', label: 'Supplier' },
  { id: 'locationName', label: 'Location' },
  { id: 'locationAddress', label: 'Location Address' },
  { id: 'locationIsLive', label: 'Location Is Live' },
  { id: 'supplierSubscriptionType', label: 'Supplier Subscription Type' },
  { id: 'status', label: 'Transaction Status' },
  { id: 'buyerTransactionStatus', label: 'Buyer Transaction Status' },
  { id: 'supplierTransactionStatus', label: 'Supplier Transaction Status' },
  { id: 'statusNotes', label: 'Status Notes' },
  { id: 'paymentMessage', label: 'Payment Message' },
  { id: 'taxStatus', label: 'Tax Status' },
  { id: 'manualPaymentCompletedOn', label: 'Buyer Payment Received Date' },
  { id: 'refundForTransactionNumber', label: 'Original Invoice' },
  { id: 'refundTransactionNumbers', label: 'Refund Invoice(s)' },
];

export {
  headCells
};